<template>
  <Modal class="confirm-modal" @close="cancel" v-if="modals.confirm">
    <h3>{{ title }}</h3>
    <p>{{ message }}</p>
    <div class="checkbox-group" v-if="checkbox">
      <label>
        <input type="checkbox" v-model="checkboxValue" />
        {{ checkbox.label }}
      </label>
    </div>
    <div class="button-group" :class="{ 'single-button': !showCancelButton }">
      <div class="button confirm-btn" @click="confirm">
        {{ confirmText }}
      </div>
      <div class="button cancel-btn" @click="cancel" v-if="showCancelButton">
        {{ cancelText }}
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "./Modal";
import { mapMutations, mapState } from "vuex";

export default {
  components: {
    Modal,
  },
  data() {
    return {
      checkboxValue: false,
    };
  },
  computed: {
    ...mapState(["modals"]),
    title() {
      return this.modals.confirmData?.title || this.$t("common.confirm");
    },
    message() {
      return this.modals.confirmData?.message || "";
    },
    confirmText() {
      return this.modals.confirmData?.confirmText || this.$t("common.confirm");
    },
    cancelText() {
      return this.modals.confirmData?.cancelText || this.$t("common.cancel");
    },
    checkbox() {
      return this.modals.confirmData?.checkbox || null;
    },
    showCancelButton() {
      // Always show cancel button unless explicitly set to false
      return this.modals.confirmData?.showCancelButton !== false;
    },
  },
  watch: {
    'modals.confirm'(newVal) {
      if (newVal && this.checkbox) {
        this.checkboxValue = this.checkbox.checked || false;
      }
    },
  },
  methods: {
    confirm() {
      if (this.modals.confirmData?.onConfirm) {
        this.modals.confirmData.onConfirm(this.checkboxValue);
      }
      this.toggleModal("confirm");
    },
    cancel() {
      if (this.modals.confirmData?.onCancel) {
        this.modals.confirmData.onCancel();
      }
      this.toggleModal("confirm");
    },
    ...mapMutations(["toggleModal"]),
  },
};
</script>

<style lang="scss">
.confirm-modal {
  .top-right-buttons {
    display: none !important;
  }

  .modal {
    max-width: 400px !important;
    min-width: 300px;
    padding: 20px 25px !important;
  }
  
  h3 {
    display: none !important;
  }

  p {
    margin: 0 0 20px;
    text-align: center;
    font-size: 14px;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.9);
    white-space: pre-wrap;
    word-break: break-word;
  }

  .checkbox-group {
    margin: 0 0 20px;
    padding: 12px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    
    label {
      display: flex;
      align-items: center;
      cursor: pointer;
      font-size: 13px;
      gap: 10px;
      
      input[type="checkbox"] {
        width: 18px;
        height: 18px;
        cursor: pointer;
        flex-shrink: 0;
      }
    }
  }

  .button-group {
    display: flex;
    justify-content: center;
    gap: 8px;

    &.single-button {
      .button {
        max-width: 150px;
      }
    }

    .button {
      flex: 1;
      min-width: 80px;
      padding: 8px 16px;
      cursor: pointer;
      font-size: 13px;
      font-weight: 500;
      border-radius: 20px;
      transition: all 0.2s ease;
      text-align: center;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      border: none;

      &.confirm-btn {
        background: #007bff;
        color: white;
        
        &:hover {
          background: #0069d9;
          box-shadow: 0 3px 6px rgba(0, 123, 255, 0.25);
        }
        
        &:active {
          background: #0056b3;
          transform: scale(0.98);
        }
      }

      &.cancel-btn {
        background: #dc3545;
        color: white;
        
        &:hover {
          background: #c82333;
          box-shadow: 0 3px 6px rgba(220, 53, 69, 0.25);
        }
        
        &:active {
          background: #bd2130;
          transform: scale(0.98);
        }
      }
    }
  }
}
</style>
